import * as React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import UniversalLink from "§/src/utils/UniversalLink"

// Functions
// Internal
import './_tile-content-product-mini.scss';

// Atoms
import ProductBadge from "§/src/components/atoms/badge/product-badge"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

// Language
import { useTranslation } from 'react-i18next';

const TileContentProductMini = (props) => {
  const { t } = useTranslation();

  // Destrutturazione sicura con valori di default
  const { title, data = [], menuOrder, ...atomProps } = props;
  const products = data || [];

  // Verifica se l'array products è valido
  const hasProducts = Array.isArray(products) && products.length > 0;

  // set atom class
  const atomClassName = 'product-mini';
  const atomClass = props?.className !== undefined
    ? atomClassName + ' ' + props.className
    : atomClassName;

  return (
    <div {...atomProps} className={atomClass}>
      {title && (
        <div className="tcpm-title">{title}</div>
      )}
      <div className="d-flex flex-column gap-2">
        {hasProducts && products
          .filter(product => {
            // Verifica che product e product.acf esistano prima di filtrare
            return product &&
                   product.acf &&
                   product.acf.badge !== "phase_out" &&
                   product.acf.badge !== "eop";
          })
          .map((product, productIndex) => {
            // Estrai variabili per accessi sicuri alle proprietà
            const featuredImage = product?.featuredImage;
            const imageData = featuredImage?.node?.gatsbyImage
              ? getImage(featuredImage.node.gatsbyImage)
              : null;
            const imageAlt = featuredImage?.altText || '';
            const productTitle = product?.title || '';
            const productBadge = product?.acf?.badge;
            const productSubtitle = product?.acf?.subTitle || '';
            const productUri = product?.uri || '#';

            return (
              <div className="tcpm-product" key={productIndex}>
                <div className="prd-image">
                  {imageData && (
                    <GatsbyImage
                      className="image"
                      image={imageData}
                      objectFit="contain"
                      alt={imageAlt}
                    />
                  )}
                </div>
                <div className="prd-desc">
                  <div className="prd-title">
                    <h5>{productTitle}</h5>
                    {productBadge && (
                      <ProductBadge data={productBadge} size="sm" />
                    )}
                  </div>
                  <div className="prd-description">{productSubtitle}</div>
                  <UniversalLink to={productUri}>
                    <ButtonArrow
                      dir="end"
                      text={t('Maggiori informazioni')}
                      className="prd-cta text-black stretched-link static"
                    />
                  </UniversalLink>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default TileContentProductMini
